export class Literals {

  public static SCENARIO = "scenario";
  public static STEP = "step";
  public static FEATURE = "feature";
  public static SUITE = "suite";
  public static NONE = "none";
  public static error = "error";
  public static Error = "Error";
  public static dataSetDoesNotExists = "Dataset does not exists or Deleted";
  public static errorInDownloadingDataset = "Error in downloading dataset";
  public static logDoesNotExists = "Log does not exists";
  public static errorInDownloadingLogs = "Error in downloading log";
  public static errorInGeneratingUrl = "Error in generating url";
  public static Completed = "Completed";
  public static Failed = "Failed";
  public static executionFailed = "Execution Failed";
  public static STEPEXECUTION = "stepexecution";
  public static video = "video";
  public static EXECUTE_FRAMEWORK = "EXECUTE_FRAMEWORK";
  public static text = "text";
  public static blank = "_blank";
  public static db1 = "db1";
  public static ide = "ide";
  public static db2 = "db2";
  public static ERROR = "ERROR";
  public static GITHUB_REAUTH_REQUIRED = "GITHUB_REAUTH_REQUIRED";
  public static EXECUTION_QUOTA_AVAILABLE = "executionQuotaAvailable";
  public static CANVAS = "CANVAS";
  public static CAPITAL_SUCCESS = "SUCCESS";
  public static SMALL_SUCCESS = "success";
  public static Warning = "Warning";
  public static Success = "Success";
  public static projectId = "projectId";
  public static GENERATING_CODE = "GENERATING_CODE";
  public static STITCH_FRAMEWORK = "STITCH_FRAMEWORK";
  public static DEPLOY_FRAMEWORK = "DEPLOY_FRAMEWORK";
  public static STATISTIC = "statistic";
  public static SCHEDULE = "schedule";
  // Gesture Literals
  public static TAP = "tap";
  public static DOUBLE_TAP = "doubletap";
  public static LONG_PRESS = "longpress";
  public static SWIPE = "swipe";
  public static TYPE = "type";
  public static ZOOM_IN = "zoom-in";
  public static ZOOM_OUT = "zoom-out";
  public static TWO_FINGER_SWIPE = "twofinger-swipe";
  public static THREE_FINGER_SWIPE = "threefinger-swipe";
  public static PRESS_HOME = "press-home";
  public static PRESS_BACK = "press-back";
  public static PRESS_RECENTS = "press-recents";
  public static PRESS_VOLUME_UP = "press-volumeup";
  public static PRESS_VOLUME_DOWN = "press-volumedown";
  public static PRESS_POWER = "press-power";
  public static KEYBOARD_ACTION = "keyboard-action";
  public static GET_TEXT = "get-text";
  public static TAP_AND_TYPE = "tap and type";
  public static SLIDER = "slider";

  //scheduler literals
  public static SUITE_NAME = "suiteName";
}
